import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
// eslint-disable-next-line boundaries/element-types
import { SEARCH_PARAM_EXPLORATION_ID } from 'features/drilldown'
import { z } from 'zod'

const drilldownExplorationSchema = z.object({
  [SEARCH_PARAM_EXPLORATION_ID]: z.string().optional(),
})
export const Route = createFileRoute('/drilldown-exploration/$siteID')({
  component: RouteComponent,
  validateSearch: zodValidator(drilldownExplorationSchema),
})

function RouteComponent() {
  return <div>Hello &quot;drilldown-exploration&quot;!</div>
}
